import { RouteDirectionsResponse, RouteRequest } from '@/models/Route'
import { HttpService } from './common/HttpService'
import { AxiosResponse } from 'axios'

const httpService: HttpService = new HttpService()
export default {
  getDirectionsForRoute(
    request: RouteRequest
  ): Promise<AxiosResponse<RouteDirectionsResponse>> {
    const url = `/google/route/directions`
    return httpService.post(url, request)
  },
}
